"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _KeyStore = require("crm_data/store/KeyStore");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _TimelineConstants = require("crm_universal/timeline/TimelineConstants");

var _immutable = require("immutable");

var EMAIL_CLICK = _TimelineConstants.TRACKED_EVENT_TYPES.EMAIL_CLICK,
    EMAIL_OPEN = _TimelineConstants.TRACKED_EVENT_TYPES.EMAIL_OPEN;

function getId(timelineItem) {
  var id = timelineItem.getIn(['eventData', 'sentBy', 'id']) || timelineItem.getIn(['engagement', 'id']) || timelineItem.getIn(['eventData', 'engagement', 'id']) || timelineItem.getIn(['eventData', 'id']) || timelineItem.get('id');
  return "" + id;
}

function getTimelineItems(data) {
  if (data.sampleEvents) {
    return data.sampleEvents;
  }

  return data.get('events');
}

function getSidekickEvents(timelineItem) {
  var type = timelineItem.getIn(['eventData', 'type']);
  var sources = timelineItem.getIn(['eventData', 'sources']);

  if (type === EMAIL_OPEN || type === EMAIL_CLICK) {
    return sources.reduce(function (map, source) {
      var timestamp = source.get('timestamp');
      var id = type + "-" + timestamp;
      var sourceEvent = timelineItem.set('timestamp', timestamp).setIn(['eventData', 'id'], id).setIn(['eventData', 'sources'], (0, _immutable.List)([source]));
      return map.set(id, sourceEvent);
    }, (0, _immutable.Map)());
  }

  return null;
}

function getUpdatedMarketingEmail(marketingEmail1, marketingEmail2) {
  var toMarketingEmail;
  var fromMarketingEmail;

  if (marketingEmail1.hasIn(['eventData', 'obsoletedBy'])) {
    toMarketingEmail = marketingEmail2;
    fromMarketingEmail = marketingEmail1;
  } else {
    toMarketingEmail = marketingEmail1;
    fromMarketingEmail = marketingEmail2;
  }

  var subject = fromMarketingEmail.getIn(['eventData', 'subject']);
  var created = fromMarketingEmail.getIn(['eventData', 'created']);
  var type = toMarketingEmail.getIn(['eventData', 'type']);
  toMarketingEmail = toMarketingEmail.setIn(['eventData', 'subject'], subject); // Set created because this is what we use to fetch correlatedEvents,
  // which has the reason why the email was dropped

  if (type === _TimelineConstants.EMAIL_EVENT_EVENT_TYPES.DROPPED) {
    toMarketingEmail = toMarketingEmail.setIn(['eventData', 'created'], created);
  }

  return toMarketingEmail;
}

var _default = (0, _KeyStore.defineKeyStore)({
  namespace: 'TIMELINE_EVENTS',
  idIsValid: function idIsValid(id) {
    return typeof id === 'string';
  }
}).defineResponseTo([_ActionTypes.ADD_SAMPLE_TIMELINE_ITEMS, _ActionTypes.FETCH_TIMELINE_ITEMS_SUCCESS, _ActionTypes.POLLING_FETCH_TIMELINE_ITEMS_SUCCESS, _ActionTypes.FETCH_TIMELINE_ITEMS_FOR_VFP_SUCCESS], function (state, data) {
  var timelineItems = getTimelineItems(data);

  if (!timelineItems || !timelineItems.size) {
    return state;
  }

  timelineItems.forEach(function (timelineItem) {
    if (timelineItem.get('etype') === _TimelineConstants.EVENT_SIDEKICK) {
      state = state.merge(getSidekickEvents(timelineItem));
    } else {
      var id = getId(timelineItem);

      if (state.get(id) && timelineItem.getIn(['eventData', 'cosEmail'])) {
        timelineItem = getUpdatedMarketingEmail(timelineItem, state.get(id));
      }

      state = state.set(id, timelineItem);
    }
  });
  return state;
}).defineResponseTo(_ActionTypes.DELETE_TIMELINE_ENGAGEMENT, function (state, _ref) {
  var engagement = _ref.engagement;
  var id = getId(engagement);
  return state.delete(id);
}).defineResponseTo(_ActionTypes.ADD_ENGAGEMENT, function (state, _ref2) {
  var engagement = _ref2.engagement;
  var id = getId(engagement);
  return state.set(id, engagement);
}).defineResponseTo(_ActionTypes.NAVIGATE, function () {
  return (0, _immutable.Map)();
}).register();

exports.default = _default;
module.exports = exports.default;